import React, { Fragment } from 'react';

import { Chevron } from 'components/Shared/Icons/Icons';
import { colors } from 'styles/cp';

export interface Props {
  opened: boolean;
  handler: () => void;
  display?: string;
  float?: string;
  margin?: string;
  btnStyling?: Record<string, string | number>;
  ariaLabel: string;
  tabIndex?: number;
}

const ExtendBtn: React.FC<Props> = (props) => {
  const {
    opened = false,
    handler,
    display = 'inline',
    float = 'right',
    margin = 'auto',
    btnStyling = {},
    ariaLabel,
    tabIndex,
  } = props;

  return (
    <Fragment>
      <button
        className="chevron-btn"
        style={btnStyling}
        data-testid="extend-button"
        onClick={(e) => {
          e.stopPropagation();
          handler();
        }}
        aria-expanded={opened}
        aria-label={ariaLabel}
        tabIndex={tabIndex}
      >
        <Chevron width={14} height={14} color={colors.gray03} />
      </button>

      <style jsx>{`
        .chevron-btn {
          text-align: center;
          height: 18px;
          margin: ${margin};
          display: ${display};
          float: ${float};
          border: none;
          background-color: inherit;
          cursor: pointer;
        }

        .chevron-btn :global(svg) {
          transition: all 0.15s linear;
          transform: rotate(${opened ? 0 : 180}deg);
        }
      `}</style>
    </Fragment>
  );
};

export default ExtendBtn;
